import React from 'react';

import dayjs from 'dayjs';
import styled from 'styled-components';

import { getIncentiveDateAndCareTypeTestId, getIncentiveTestId } from './testIdUtils';
import { LIVING_TYPES_ABBREVIATIONS } from '../../constants/livingTypes';
import { CommunityBaseIncentiveType } from '../../types/incentives';

const Container = styled.div`
  display: flex;
  flex-flow: column;
  gap: 10px;
`;

const SubContainer = styled.div`
  display: flex;
  flex-flow: column;
`;

const Title = styled.div`
  font-size: 12px;
`;

const Subtitle = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  color: var(--text-secondary);
  font-size: 12px;
`;

type Props = {
  incentives: CommunityBaseIncentiveType[];
  dataTestId?: string;
  competitorIndex?: number;
};

const CMASummaryTableDataIncentives = ({ incentives, dataTestId, competitorIndex }: Props) => (
  <Container data-test-id={dataTestId}>
    {incentives?.map((incentive, incentiveIndex) => {
      const incentiveTestId = getIncentiveTestId(incentiveIndex, competitorIndex);
      return (
        <SubContainer key={incentive.id} data-test-id={incentiveTestId}>
          <Title>{incentive.description}</Title>
          <Subtitle data-test-id={getIncentiveDateAndCareTypeTestId(incentiveTestId)}>
            <div>{dayjs(incentive.date).format('MMM DD YYYY')}</div>
            {incentive.living_types.length > 0 && (
              <>
                <span>·</span>
                <div style={{ display: 'flex', gap: 2 }}>
                  {incentive.living_types.map((livingType, idx) => (
                    <span key={idx}>
                      {LIVING_TYPES_ABBREVIATIONS[livingType]}
                      {idx !== incentive.living_types.length - 1 ? ',' : ''}
                    </span>
                  ))}
                </div>
              </>
            )}
          </Subtitle>
        </SubContainer>
      );
    })}
  </Container>
);

export default CMASummaryTableDataIncentives;
